<template>
  <div class="wp-block-group section-title">
    <div class="wp-block-group__inner-container">
      <h2>{{title}}</h2>

      <template v-if="isLoggedIn">
        <template v-if="isNotHomePage && afterSecondLevel()">
          <div class="wp-block-group__download-buttons">
            <span>
              <button class="button__download js-generate-excel" type="button" @click="generateCategoryExcel">
                <img :src="excelUrl" alt="Excel icon">
                {{ this.translations.download }}
                <i data-feather="download"></i>
              </button>
            </span>
          </div>
        </template>
      </template>

      <template v-else="">
        <template v-if="hasProducts">
          <div class="wp-block-group__download-buttons">
            <span>
              <button class="button__download js-generate-excel" type="button" @click="generateExcel">
                <img :src="excelUrl" alt="Excel icon">
                {{ this.translations.download }}
                <i data-feather="download"></i>
              </button>
            </span>
            <!-- <span>
              <button class="button__download js-print-pdf" type="button" @click="generatePDF">
                <img :src="pdfURL" alt="PDF icon">
                {{ this.translations.download }}
                <i data-feather="download"></i>
              </button>
            </span> -->
          </div>
        </template>
      </template>

      <p v-if="description">{{description}}</p>
      <hr class="wp-block-separator" v-if="displayHR">
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
<script>

export default {
  name: "KaaliTitle",
  components: {
  },
  props: {
    title: String,
    description: {
      type: String,
      default: ''
    },
    displayHR: Boolean
  },
  data() {
    return {
      isLoggedIn: Boolean(ws_vue_store.logged_in),
      translations: {
        download: ws_vue_store.translations.file_download
      },
      excelUrl: ws_vue_store.site_url + '/wp-content/themes/hekamerk/assets/src/img/svg/XSL.svg',
      pdfURL: ws_vue_store.site_url + '/wp-content/themes/hekamerk/assets/src/img/svg/PDF.svg',
    }
  },
  computed: {
    hasProducts() {
      return this.$store.state.products && this.$store.state.products.length > 0;
    },
    isNotHomePage() {
      return !this.$store.getters.isHomePage();
    }
  },
  methods: {
    afterSecondLevel() {
      if (this.$store.state.filters.current && this.$store.state.filters.current.product_cat) {
        let level = 0;
        let categoryID = this.$store.state.filters.current.product_cat[0];
        let category = null;
        while (categoryID) {
          level++;
          category = this.$store.state.categories.find(e => e.term_id === categoryID);
          categoryID = category.parent;
        }
        return level > 1;
      }
      return false;
    },
    generateExcel() {
      document.dispatchEvent(new Event('wsExcelGenerate'));
    },
    generateCategoryExcel() {
      if (this.$store.state.filters.current && this.$store.state.filters.current.product_cat) {
        let currentCategoryID = this.$store.state.filters.current.product_cat[0];
        let currentCategory = this.$store.state.categories.find(e => e.term_id === currentCategoryID);
        if (currentCategory) {
          let categories = [];
          let isParentView = false;
          this.subCategories(currentCategoryID, categories);

          if (categories.length) {
            isParentView = true;
          } else {
            categories.push(currentCategory);
            currentCategory = this.$store.state.categories.find(e => e.term_id === currentCategory.parent);
          }

          let data = {
            'categories': categories,
            'parent': currentCategory,
            'isParentView': isParentView
          };
          document.dispatchEvent(new CustomEvent('wsExcelGenerateCategory', {detail: data}));
        }

      }
    },
    subCategories(categoryID, returnData) {
      let subCategories = this.$store.state.categories.filter(
        (filterCategory) => filterCategory.parent === categoryID
      );
      for (const category of subCategories) {
        returnData.push(category);
        if (category.children.length) {
          this.subCategories(category.term_id, returnData);
        }
      }
    },
    generatePDF() {
      document.dispatchEvent(new Event('wsPDFPrint'));
    }
  }
};
</script>
